<template>
  <div class="equipment">
    <div class="home_carousel">
      <div class="carousel_img">
        <div class="carousel_con">
          <h2>推动企业</h2>
          <h2>让采购更加智能、高效、透明</h2>
          <div class="englishTitle">
            <div>Promote enterprises</div>
            <div>Make procurement more intelligent, efficien</div>
          </div>
          <div class="line"></div>
          <button @click="applyShow" class="btn">立即申请试用</button>
        </div>
        <div></div>
      </div>
    </div>
    <div class="title"><h1>产品服务</h1></div>
    <div class="productBox">
      <div class="product_hang">
        <div class="product_data" v-for="(item, index) in imgData" :key="index">
          <div class="imgBox">
            <!-- <div class="img"
              :style="{ 'background-image': 'url(' + item.img + ')','background-repeat':'no-repeat','background-size':'cover' }"
              >
            </div> -->
            <img :src="item.img" alt="" />
          </div>
          <div class="message">
            <div class="name">{{ item.name }}</div>
            <div class="line"></div>
            <div class="ping">主屏</div>
            <div class="jieshao">{{ item.msg1 }}</div>
            <div class="ping">副屏</div>
            <div class="jieshao jieshao2">{{ item.msg2 }}</div>
          </div>
        </div>
      </div>
    </div>
    <ApplyDialog :show.sync="show"></ApplyDialog>
  </div>
</template>

<script>
import SlideBar from "../components/sidebar.vue";
import ApplyDialog from "../components/applyDialog.vue";
export default {
  components: {
    SlideBar,
    ApplyDialog,
  },
  data() {
    return {
      show: false,
      imgData: [
        {
          img: require("../assets/equipment1.png"),
          name: "FT1 海马一代",
          msg1: "7寸、分辨率1024*600、多点触摸电容屏",
          msg2: "4寸、分辨率400*800",
        },
        {
          img: require("../assets/equipment2.png"),
          name: "新开普A832",
          msg1: "8寸、分辨率1280*800、多点触摸电容屏",
          msg2: "5寸、分辨率1280*720、多点触摸电容屏",
        },
        {
          img: require("../assets/equipment3.png"),
          name: "乐舜LSF910",
          msg1: "8寸、分辨率800*1280、多点触摸电容屏",
          msg2: "5寸、分辨率480*854、多点触摸电容屏",
        },
        {
          img: require("../assets/equipment4.png"),
          name: "FT1 海马一代+支架",
          msg1: "7寸、分辨率1024*600、多点触摸电容屏",
          msg2: "4寸、分辨率480*800",
        },
        {
          img: require("../assets/equipment5.png"),
          name: "新开普A732",
          msg1: "8寸、分辨率1280*800、多点触摸电容屏",
          msg2: "5寸、分辨率1280*720、多点触摸电容屏",
        },
        {
          img: require("../assets/equipment6.png"),
          name: "商米D2",
          msg1: "15.6寸，分辨率1366*768",
          msg2: "10.1寸，分辨率1024*600",
        },
        {
          img: require("../assets/equipment6.png"),
          name: "天波TPS650双屏",
          msg1: "15.6寸，分辨率1920*1080,多点触摸电容屏",
          msg2: "15.6寸，分辨率1920*1080,多点触摸电容屏",
        },
        {
          img: require("../assets/equipment7.png"),
          name: "天波TPS650单屏",
          msg1: "15.6寸，分辨率1920*1080,多点触摸电容屏",
          msg2: "无",
        },
        {
          img: require("../assets/equipment8.png"),
          name: "方派FP-VS100",
          msg1: "10.1寸，分辨率800*1280，多点触控",
          msg2: "无",
        },
      ],
    };
  },
  methods: {
    applyShow() {
      this.show = true;
      // 禁止滚动
      this.noScroll();
      let arr = "this is a b c";
      console.log(arr.split("").reverse().join(""), "0000");
    },
  },
};
</script>

<style lang="scss" scoped>
.carousel_img {
  background: url("../assets/equipment9.png") no-repeat center center;
  background-size: cover;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 7.5rem 2.5rem 7.5rem;
  height: 40.3125rem;

  .carousel_con {
    display: block;
    width: 48%;
    animation: fadenum 2s;
    & > h2 {
      font-size: 2.125rem;
      font-weight: bold;
      color: #333333;
    }
    .englishTitle {
      font-size: 0.75rem;
      font-weight: 400;
      color: #333333;
      opacity: 0.6;
      margin-top: 3.875rem;
    }

    .line {
      width: 1.875rem;
      height: 0.25rem;
      background: #0e6eb8;
      margin: 2.5rem 0;
    }

    & > button {
      font-size: 1.25rem;
      font-weight: 400;
      background: none;
      color: #2777b9;
      padding: 1.1875rem 1.9375rem;
      border-radius: 0.25rem;
      border: 0.125rem solid #2777b9;
      cursor: pointer;
    }
    & > button:hover {
      background: #0e6eb8;
      color: #ffffff;
      transition: 0.2s;
    }
  }
  @keyframes fadenum {
    0% {
      transform: translateX(-150px);
    }
  }
}
.title h1 {
  text-align: center;
  font-size: 2.5rem;
  font-weight: bold;
  padding: 6.25rem 0 3.75rem 0;
}
.productBox {
  margin: 1rem 7.5rem 2.5rem 7.5rem;
  .product_hang {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .product_data:hover {
      box-shadow: 0px 0px 2rem 0px rgba(1, 20, 35, 0.08);
    }
    .product_data {
      display: flex;
      flex-direction: column;
      width: 40%;
      // min-height: 28.125rem;
      margin-bottom: 3.125rem;
      padding-bottom: 3.125rem;
      border: 0.125rem solid #eeeeee;
      border-radius: 0.625rem;
      .imgBox {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 50%;
        background: #f9f9f9;
        overflow: hidden;

        img {
          width: 21.25rem;
          height: 11.25rem;
          object-fit: contain;
          // transition: all .1s linear .1s;
        }
        img:hover {
          transform: scale(1.3);
        }
      }

      .message {
        display: flex;
        flex-direction: column;
        padding: 1.875rem 1.875rem 1.875rem 3.75rem;
        background-color: #ffffff;
        .name {
          font-size: 1.5rem;
          font-weight: bold;
          color: #333333;
          margin-bottom: 0.625rem;
        }
        .line {
          width: 1.875rem;
          height: 0.25rem;
          background: #0e6eb8;
          margin-bottom: 0.625rem;
        }
        .ping {
          font-size: 1rem;
          font-weight: bold;
          color: #333333;
        }
        .jieshao {
          margin-bottom: 1.25rem;
          &.jieshao2 {
            margin-bottom: 0;
          }
        }
      }
    }
  }
}
</style>
<style>
@media screen and (max-width: 600px) {
  html,
  body {
    width: 100vw;
    overflow: auto;
  }
  .productBox {
    margin: 0 !important;
    padding: 0 20px !important;
  }
  .product_hang {
    flex-flow: column;
  }
  .product_data {
    width: 100% !important;
    /* padding-bottom: 20px !important; */
  }
}
</style>